import styled from "styled-components";

export const Container = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  &.theme-4 {
    padding: 50px 0 0;
  }
`;
